import getAxios from '@/utils/axios-request'

export async function getCategoryList() {
  const axios = await getAxios('marketplace')
  return axios({
    url: '/static_content_store?category_code=eq.api_category',
    method: 'get'
  })
}
